(ns shared.core.amelia-light.components.icon
  (:require [shared.core.components.icon :as icon]
            [shared.core.style :as style]
            ["@up/base-ui/icons/common/AIAgentIcon" :default common--AIAgentIcon]
            ["@up/base-ui/icons/common/AddBoxIcon" :default common--AddBoxIcon]
            ["@up/base-ui/icons/common/AddCircleOutlineIcon" :default common--AddCircleOutlineIcon]
            ["@up/base-ui/icons/common/AddFromIcon" :default common--AddFromIcon]
            ["@up/base-ui/icons/common/AddIcon" :default common--AddIcon]
            ["@up/base-ui/icons/common/AddRhombusIcon" :default common--AddRhombusIcon]
            ["@up/base-ui/icons/common/AdminIcon" :default common--AdminIcon]
            ["@up/base-ui/icons/common/AiSummaryIcon" :default common--AiSummaryIcon]
            ["@up/base-ui/icons/common/AlertIcon" :default common--AlertIcon]
            ["@up/base-ui/icons/common/AnnouncementIcon" :default common--AnnouncementIcon]
            ["@up/base-ui/icons/common/ArchiveIcon" :default common--ArchiveIcon]
            ["@up/base-ui/icons/common/ArrRightAltIcon" :default common--ArrRightAltIcon]
            ["@up/base-ui/icons/common/ArrayIcon" :default common--ArrayIcon]
            ["@up/base-ui/icons/common/ArrowDownIcon" :default common--ArrowDownIcon]
            ["@up/base-ui/icons/common/ArrowEndIcon" :default common--ArrowEndIcon]
            ["@up/base-ui/icons/common/ArrowLeftIcon" :default common--ArrowLeftIcon]
            ["@up/base-ui/icons/common/ArrowRightIcon" :default common--ArrowRightIcon]
            ["@up/base-ui/icons/common/ArrowTopIcon" :default common--ArrowTopIcon]
            ["@up/base-ui/icons/common/ArrowUpIcon" :default common--ArrowUpIcon]
            ["@up/base-ui/icons/common/AtIcon" :default common--AtIcon]
            ["@up/base-ui/icons/common/AttachFileIcon" :default common--AttachFileIcon]
            ["@up/base-ui/icons/common/AttachmentIcon" :default common--AttachmentIcon]
            ["@up/base-ui/icons/common/AutolayoutIcon" :default common--AutolayoutIcon]
            ["@up/base-ui/icons/common/AutomatonIcon" :default common--AutomatonIcon]
            ["@up/base-ui/icons/common/BarChartIcon" :default common--BarChartIcon]
            ["@up/base-ui/icons/common/BatchUpdatesIcon" :default common--BatchUpdatesIcon]
            ["@up/base-ui/icons/common/BigAddIcon" :default common--BigAddIcon]
            ["@up/base-ui/icons/common/BigEmptyIcon" :default common--BigEmptyIcon]
            ["@up/base-ui/icons/common/BigErrorIcon" :default common--BigErrorIcon]
            ["@up/base-ui/icons/common/BigUploadIcon" :default common--BigUploadIcon]
            ["@up/base-ui/icons/common/BlocsIcon" :default common--BlocsIcon]
            ["@up/base-ui/icons/common/BooleanIcon" :default common--BooleanIcon]
            ["@up/base-ui/icons/common/BotIcon" :default common--BotIcon]
            ["@up/base-ui/icons/common/BucketIcon" :default common--BucketIcon]
            ["@up/base-ui/icons/common/BugReportIcon" :default common--BugReportIcon]
            ["@up/base-ui/icons/common/BulkIcon" :default common--BulkIcon]
            ["@up/base-ui/icons/common/BurgerMenuIcon" :default common--BurgerMenuIcon]
            ["@up/base-ui/icons/common/CalendarIcon" :default common--CalendarIcon]
            ["@up/base-ui/icons/common/CallEndIcon" :default common--CallEndIcon]
            ["@up/base-ui/icons/common/CallIcon" :default common--CallIcon]
            ["@up/base-ui/icons/common/CallMissedIcon" :default common--CallMissedIcon]
            ["@up/base-ui/icons/common/CallbackIcon" :default common--CallbackIcon]
            ["@up/base-ui/icons/common/ChangeUserIcon" :default common--ChangeUserIcon]
            ["@up/base-ui/icons/common/ChatIcon" :default common--ChatIcon]
            ["@up/base-ui/icons/common/CheckCircleIcon" :default common--CheckCircleIcon]
            ["@up/base-ui/icons/common/CheckSquareIcon" :default common--CheckSquareIcon]
            ["@up/base-ui/icons/common/ChevronDownIcon" :default common--ChevronDownIcon]
            ["@up/base-ui/icons/common/ChevronLeftIcon" :default common--ChevronLeftIcon]
            ["@up/base-ui/icons/common/ChevronRightIcon" :default common--ChevronRightIcon]
            ["@up/base-ui/icons/common/ChevronTopIcon" :default common--ChevronTopIcon]
            ["@up/base-ui/icons/common/CityIcon" :default common--CityIcon]
            ["@up/base-ui/icons/common/CleanIcon" :default common--CleanIcon]
            ["@up/base-ui/icons/common/ClientIcon" :default common--ClientIcon]
            ["@up/base-ui/icons/common/CloneIcon" :default common--CloneIcon]
            ["@up/base-ui/icons/common/CloudOffIcon" :default common--CloudOffIcon]
            ["@up/base-ui/icons/common/CloudSyncIcon" :default common--CloudSyncIcon]
            ["@up/base-ui/icons/common/CloudUploadedIcon" :default common--CloudUploadedIcon]
            ["@up/base-ui/icons/common/CodeIcon" :default common--CodeIcon]
            ["@up/base-ui/icons/common/CompressVertIcon" :default common--CompressVertIcon]
            ["@up/base-ui/icons/common/CopyIcon" :default common--CopyIcon]
            ["@up/base-ui/icons/common/CreateNewFolderIcon" :default common--CreateNewFolderIcon]
            ["@up/base-ui/icons/common/CrossCircleIcon" :default common--CrossCircleIcon]
            ["@up/base-ui/icons/common/CrossIcon" :default common--CrossIcon]
            ["@up/base-ui/icons/common/CutContentIcon" :default common--CutContentIcon]
            ["@up/base-ui/icons/common/CutIcon" :default common--CutIcon]
            ["@up/base-ui/icons/common/DarkModeIcon" :default common--DarkModeIcon]
            ["@up/base-ui/icons/common/DeadlineIcon" :default common--DeadlineIcon]
            ["@up/base-ui/icons/common/DeleteBasketIcon" :default common--DeleteBasketIcon]
            ["@up/base-ui/icons/common/DeleteIcon" :default common--DeleteIcon]
            ["@up/base-ui/icons/common/DialpadIcon" :default common--DialpadIcon]
            ["@up/base-ui/icons/common/DisableIcon" :default common--DisableIcon]
            ["@up/base-ui/icons/common/DislikeIcon" :default common--DislikeIcon]
            ["@up/base-ui/icons/common/DocIcon" :default common--DocIcon]
            ["@up/base-ui/icons/common/DoneIcon" :default common--DoneIcon]
            ["@up/base-ui/icons/common/DotIndicatorIcon" :default common--DotIndicatorIcon]
            ["@up/base-ui/icons/common/DoubleChevronLeftIcon" :default common--DoubleChevronLeftIcon]
            ["@up/base-ui/icons/common/DoubleChevronRightIcon" :default common--DoubleChevronRightIcon]
            ["@up/base-ui/icons/common/DownloadIcon" :default common--DownloadIcon]
            ["@up/base-ui/icons/common/DowntimeIcon" :default common--DowntimeIcon]
            ["@up/base-ui/icons/common/DragIcon" :default common--DragIcon]
            ["@up/base-ui/icons/common/EditIcon" :default common--EditIcon]
            ["@up/base-ui/icons/common/EditTextIcon" :default common--EditTextIcon]
            ["@up/base-ui/icons/common/EmojiAverageIcon" :default common--EmojiAverageIcon]
            ["@up/base-ui/icons/common/EmojiBadIcon" :default common--EmojiBadIcon]
            ["@up/base-ui/icons/common/EmojiExcellentIcon" :default common--EmojiExcellentIcon]
            ["@up/base-ui/icons/common/EmojiGoodIcon" :default common--EmojiGoodIcon]
            ["@up/base-ui/icons/common/EmojiPoorIcon" :default common--EmojiPoorIcon]
            ["@up/base-ui/icons/common/EventIcon" :default common--EventIcon]
            ["@up/base-ui/icons/common/EventManagementIcon" :default common--EventManagementIcon]
            ["@up/base-ui/icons/common/ExitAllContextIcon" :default common--ExitAllContextIcon]
            ["@up/base-ui/icons/common/ExitContextIcon" :default common--ExitContextIcon]
            ["@up/base-ui/icons/common/ExitIcon" :default common--ExitIcon]
            ["@up/base-ui/icons/common/ExpandInputIcon" :default common--ExpandInputIcon]
            ["@up/base-ui/icons/common/ExpandVertIcon" :default common--ExpandVertIcon]
            ["@up/base-ui/icons/common/ExportIcon" :default common--ExportIcon]
            ["@up/base-ui/icons/common/ExternalProvidersIcon" :default common--ExternalProvidersIcon]
            ["@up/base-ui/icons/common/FaceScanIcon" :default common--FaceScanIcon]
            ["@up/base-ui/icons/common/FallbackIcon" :default common--FallbackIcon]
            ["@up/base-ui/icons/common/FeedbackIcon" :default common--FeedbackIcon]
            ["@up/base-ui/icons/common/FileCopyIcon" :default common--FileCopyIcon]
            ["@up/base-ui/icons/common/FileExcelIcon" :default common--FileExcelIcon]
            ["@up/base-ui/icons/common/FilePdfIcon" :default common--FilePdfIcon]
            ["@up/base-ui/icons/common/FilePresentationIcon" :default common--FilePresentationIcon]
            ["@up/base-ui/icons/common/FileWordIcon" :default common--FileWordIcon]
            ["@up/base-ui/icons/common/FilterIcon" :default common--FilterIcon]
            ["@up/base-ui/icons/common/FirstIcon" :default common--FirstIcon]
            ["@up/base-ui/icons/common/FitToSizeIcon" :default common--FitToSizeIcon]
            ["@up/base-ui/icons/common/FolderIcon" :default common--FolderIcon]
            ["@up/base-ui/icons/common/FolderOpenIcon" :default common--FolderOpenIcon]
            ["@up/base-ui/icons/common/FontcolorIcon" :default common--FontcolorIcon]
            ["@up/base-ui/icons/common/FunctionIcon" :default common--FunctionIcon]
            ["@up/base-ui/icons/common/GenerateIcon" :default common--GenerateIcon]
            ["@up/base-ui/icons/common/HelpFilledIcon" :default common--HelpFilledIcon]
            ["@up/base-ui/icons/common/HelpIcon" :default common--HelpIcon]
            ["@up/base-ui/icons/common/HideIcon" :default common--HideIcon]
            ["@up/base-ui/icons/common/HistoryIcon" :default common--HistoryIcon]
            ["@up/base-ui/icons/common/HomeIcon" :default common--HomeIcon]
            ["@up/base-ui/icons/common/HyperaFlightIcon" :default common--HyperaFlightIcon]
            ["@up/base-ui/icons/common/HyperaLandIcon" :default common--HyperaLandIcon]
            ["@up/base-ui/icons/common/HyperaTakeoffIcon" :default common--HyperaTakeoffIcon]
            ["@up/base-ui/icons/common/ImageIcon" :default common--ImageIcon]
            ["@up/base-ui/icons/common/ImportIcon" :default common--ImportIcon]
            ["@up/base-ui/icons/common/IndexQueuedIcon" :default common--IndexQueuedIcon]
            ["@up/base-ui/icons/common/IndexingIcon" :default common--IndexingIcon]
            ["@up/base-ui/icons/common/InfoIcon" :default common--InfoIcon]
            ["@up/base-ui/icons/common/InputIcon" :default common--InputIcon]
            ["@up/base-ui/icons/common/IntegerIcon" :default common--IntegerIcon]
            ["@up/base-ui/icons/common/KebabMenuHorzIcon" :default common--KebabMenuHorzIcon]
            ["@up/base-ui/icons/common/KebabMenuVertIcon" :default common--KebabMenuVertIcon]
            ["@up/base-ui/icons/common/LaptopIcon" :default common--LaptopIcon]
            ["@up/base-ui/icons/common/LastIcon" :default common--LastIcon]
            ["@up/base-ui/icons/common/Layout1HorIcon" :default common--Layout1HorIcon]
            ["@up/base-ui/icons/common/Layout1VerIcon" :default common--Layout1VerIcon]
            ["@up/base-ui/icons/common/Layout2HorIcon" :default common--Layout2HorIcon]
            ["@up/base-ui/icons/common/LearnIcon" :default common--LearnIcon]
            ["@up/base-ui/icons/common/LevelUpIcon" :default common--LevelUpIcon]
            ["@up/base-ui/icons/common/LightModeIcon" :default common--LightModeIcon]
            ["@up/base-ui/icons/common/LikeIcon" :default common--LikeIcon]
            ["@up/base-ui/icons/common/LinkIcon" :default common--LinkIcon]
            ["@up/base-ui/icons/common/LocationIcon" :default common--LocationIcon]
            ["@up/base-ui/icons/common/LookupIcon" :default common--LookupIcon]
            ["@up/base-ui/icons/common/Magic2Icon" :default common--Magic2Icon]
            ["@up/base-ui/icons/common/MagicIcon" :default common--MagicIcon]
            ["@up/base-ui/icons/common/MicIcon" :default common--MicIcon]
            ["@up/base-ui/icons/common/MicOffIcon" :default common--MicOffIcon]
            ["@up/base-ui/icons/common/MinimizeIcon" :default common--MinimizeIcon]
            ["@up/base-ui/icons/common/MobilePhoneIcon" :default common--MobilePhoneIcon]
            ["@up/base-ui/icons/common/MoreSettingsIcon" :default common--MoreSettingsIcon]
            ["@up/base-ui/icons/common/NoImageIcon" :default common--NoImageIcon]
            ["@up/base-ui/icons/common/NotSignedIcon" :default common--NotSignedIcon]
            ["@up/base-ui/icons/common/NotifyIcon" :default common--NotifyIcon]
            ["@up/base-ui/icons/common/ObjectIcon" :default common--ObjectIcon]
            ["@up/base-ui/icons/common/OpenInNewIcon" :default common--OpenInNewIcon]
            ["@up/base-ui/icons/common/OsWindowIcon" :default common--OsWindowIcon]
            ["@up/base-ui/icons/common/OutputIcon" :default common--OutputIcon]
            ["@up/base-ui/icons/common/PartialDoneIcon" :default common--PartialDoneIcon]
            ["@up/base-ui/icons/common/PasswordIcon" :default common--PasswordIcon]
            ["@up/base-ui/icons/common/PasteIcon" :default common--PasteIcon]
            ["@up/base-ui/icons/common/PauseIcon" :default common--PauseIcon]
            ["@up/base-ui/icons/common/PhonebookIcon" :default common--PhonebookIcon]
            ["@up/base-ui/icons/common/PhotoIcon" :default common--PhotoIcon]
            ["@up/base-ui/icons/common/PinIcon" :default common--PinIcon]
            ["@up/base-ui/icons/common/PinnedIcon" :default common--PinnedIcon]
            ["@up/base-ui/icons/common/PlayIcon" :default common--PlayIcon]
            ["@up/base-ui/icons/common/PriorityIcon" :default common--PriorityIcon]
            ["@up/base-ui/icons/common/ProcessingFaqIcon" :default common--ProcessingFaqIcon]
            ["@up/base-ui/icons/common/ProcessingSegmentsIcon" :default common--ProcessingSegmentsIcon]
            ["@up/base-ui/icons/common/Properties2Icon" :default common--Properties2Icon]
            ["@up/base-ui/icons/common/PropertiesIcon" :default common--PropertiesIcon]
            ["@up/base-ui/icons/common/ProtectedIcon" :default common--ProtectedIcon]
            ["@up/base-ui/icons/common/PublishIcon" :default common--PublishIcon]
            ["@up/base-ui/icons/common/PuzzleIcon" :default common--PuzzleIcon]
            ["@up/base-ui/icons/common/PuzzleTemplateIcon" :default common--PuzzleTemplateIcon]
            ["@up/base-ui/icons/common/QuestionmarkCircleIcon" :default common--QuestionmarkCircleIcon]
            ["@up/base-ui/icons/common/QueueIcon" :default common--QueueIcon]
            ["@up/base-ui/icons/common/RedoIcon" :default common--RedoIcon]
            ["@up/base-ui/icons/common/RefreshIcon" :default common--RefreshIcon]
            ["@up/base-ui/icons/common/RemoveCircleIcon" :default common--RemoveCircleIcon]
            ["@up/base-ui/icons/common/RemoveIcon" :default common--RemoveIcon]
            ["@up/base-ui/icons/common/RenewIcon" :default common--RenewIcon]
            ["@up/base-ui/icons/common/ReplaceIcon" :default common--ReplaceIcon]
            ["@up/base-ui/icons/common/RevisionIcon" :default common--RevisionIcon]
            ["@up/base-ui/icons/common/RingVolumeIcon" :default common--RingVolumeIcon]
            ["@up/base-ui/icons/common/RocketIcon" :default common--RocketIcon]
            ["@up/base-ui/icons/common/RulesIcon" :default common--RulesIcon]
            ["@up/base-ui/icons/common/SaveAltIcon" :default common--SaveAltIcon]
            ["@up/base-ui/icons/common/SaveIcon" :default common--SaveIcon]
            ["@up/base-ui/icons/common/SaveVersionIcon" :default common--SaveVersionIcon]
            ["@up/base-ui/icons/common/SearchIcon" :default common--SearchIcon]
            ["@up/base-ui/icons/common/SearchNotFoundIcon" :default common--SearchNotFoundIcon]
            ["@up/base-ui/icons/common/SegmentsQueuedIcon" :default common--SegmentsQueuedIcon]
            ["@up/base-ui/icons/common/SendIcon" :default common--SendIcon]
            ["@up/base-ui/icons/common/SessionIcon" :default common--SessionIcon]
            ["@up/base-ui/icons/common/Settings2Icon" :default common--Settings2Icon]
            ["@up/base-ui/icons/common/SettingsIcon" :default common--SettingsIcon]
            ["@up/base-ui/icons/common/ShiftIcon" :default common--ShiftIcon]
            ["@up/base-ui/icons/common/ShowIcon" :default common--ShowIcon]
            ["@up/base-ui/icons/common/SidebarLIcon" :default common--SidebarLIcon]
            ["@up/base-ui/icons/common/SidebarRIcon" :default common--SidebarRIcon]
            ["@up/base-ui/icons/common/SignedIcon" :default common--SignedIcon]
            ["@up/base-ui/icons/common/SlaIcon" :default common--SlaIcon]
            ["@up/base-ui/icons/common/SmallChevroneIcon" :default common--SmallChevroneIcon]
            ["@up/base-ui/icons/common/StarBorderIcon" :default common--StarBorderIcon]
            ["@up/base-ui/icons/common/StarIcon" :default common--StarIcon]
            ["@up/base-ui/icons/common/StopIcon" :default common--StopIcon]
            ["@up/base-ui/icons/common/StrikethroughIcon" :default common--StrikethroughIcon]
            ["@up/base-ui/icons/common/StringIcon" :default common--StringIcon]
            ["@up/base-ui/icons/common/SubLevelIcon" :default common--SubLevelIcon]
            ["@up/base-ui/icons/common/SubscribeIcon" :default common--SubscribeIcon]
            ["@up/base-ui/icons/common/SubscribedIcon" :default common--SubscribedIcon]
            ["@up/base-ui/icons/common/SupportIcon" :default common--SupportIcon]
            ["@up/base-ui/icons/common/TagsIcon" :default common--TagsIcon]
            ["@up/base-ui/icons/common/TasksIcon" :default common--TasksIcon]
            ["@up/base-ui/icons/common/TemplateIcon" :default common--TemplateIcon]
            ["@up/base-ui/icons/common/ThemeIcon" :default common--ThemeIcon]
            ["@up/base-ui/icons/common/TilesMenuIcon" :default common--TilesMenuIcon]
            ["@up/base-ui/icons/common/TimeFilledIcon" :default common--TimeFilledIcon]
            ["@up/base-ui/icons/common/TimeIcon" :default common--TimeIcon]
            ["@up/base-ui/icons/common/TokenIcon" :default common--TokenIcon]
            ["@up/base-ui/icons/common/TransferIcon" :default common--TransferIcon]
            ["@up/base-ui/icons/common/TranslateIcon" :default common--TranslateIcon]
            ["@up/base-ui/icons/common/TreeIcon" :default common--TreeIcon]
            ["@up/base-ui/icons/common/TxtBoldIcon" :default common--TxtBoldIcon]
            ["@up/base-ui/icons/common/TxtH1Icon" :default common--TxtH1Icon]
            ["@up/base-ui/icons/common/TxtH2Icon" :default common--TxtH2Icon]
            ["@up/base-ui/icons/common/TxtH3Icon" :default common--TxtH3Icon]
            ["@up/base-ui/icons/common/TxtH4Icon" :default common--TxtH4Icon]
            ["@up/base-ui/icons/common/TxtH5Icon" :default common--TxtH5Icon]
            ["@up/base-ui/icons/common/TxtH6Icon" :default common--TxtH6Icon]
            ["@up/base-ui/icons/common/TxtItalicIcon" :default common--TxtItalicIcon]
            ["@up/base-ui/icons/common/TxtListBulletedIcon" :default common--TxtListBulletedIcon]
            ["@up/base-ui/icons/common/TxtListNumberedIcon" :default common--TxtListNumberedIcon]
            ["@up/base-ui/icons/common/TxtQuoteIcon" :default common--TxtQuoteIcon]
            ["@up/base-ui/icons/common/TxtStrikethroughIcon" :default common--TxtStrikethroughIcon]
            ["@up/base-ui/icons/common/TxtUnderlinedIcon" :default common--TxtUnderlinedIcon]
            ["@up/base-ui/icons/common/UndoIcon" :default common--UndoIcon]
            ["@up/base-ui/icons/common/UnlinkIcon" :default common--UnlinkIcon]
            ["@up/base-ui/icons/common/UpdatedIcon" :default common--UpdatedIcon]
            ["@up/base-ui/icons/common/UpgradeIcon" :default common--UpgradeIcon]
            ["@up/base-ui/icons/common/UploadIcon" :default common--UploadIcon]
            ["@up/base-ui/icons/common/UroutedIcon" :default common--UroutedIcon]
            ["@up/base-ui/icons/common/UserAvaIcon" :default common--UserAvaIcon]
            ["@up/base-ui/icons/common/UserCaseIcon" :default common--UserCaseIcon]
            ["@up/base-ui/icons/common/UserIcon" :default common--UserIcon]
            ["@up/base-ui/icons/common/UserOutlineIcon" :default common--UserOutlineIcon]
            ["@up/base-ui/icons/common/UserProtectionIcon" :default common--UserProtectionIcon]
            ["@up/base-ui/icons/common/UsersDispatchIcon" :default common--UsersDispatchIcon]
            ["@up/base-ui/icons/common/VideoembedIcon" :default common--VideoembedIcon]
            ["@up/base-ui/icons/common/VocabularyIcon" :default common--VocabularyIcon]
            ["@up/base-ui/icons/common/VoiceChatIcon" :default common--VoiceChatIcon]
            ["@up/base-ui/icons/common/VolumeOffIcon" :default common--VolumeOffIcon]
            ["@up/base-ui/icons/common/VolumeOnIcon" :default common--VolumeOnIcon]
            ["@up/base-ui/icons/common/WarningIcon" :default common--WarningIcon]
            ["@up/base-ui/icons/common/WebIcon" :default common--WebIcon]
            ["@up/base-ui/icons/common/WebhookIcon" :default common--WebhookIcon]
            ["@up/base-ui/icons/common/ZoomExpandIcon" :default common--ZoomExpandIcon]
            ["@up/base-ui/icons/common/ZoomInIcon" :default common--ZoomInIcon]
            ["@up/base-ui/icons/common/ZoomOutIcon" :default common--ZoomOutIcon]
            ["@up/base-ui/icons/designer/ActionIcon" :default designer--ActionIcon]
            ["@up/base-ui/icons/designer/AiopsIcon" :default designer--AiopsIcon]
            ["@up/base-ui/icons/designer/AlarmIcon" :default designer--AlarmIcon]
            ["@up/base-ui/icons/designer/AmeliaAsksIcon" :default designer--AmeliaAsksIcon]
            ["@up/base-ui/icons/designer/AmeliaSaysIcon" :default designer--AmeliaSaysIcon]
            ["@up/base-ui/icons/designer/BulbIcon" :default designer--BulbIcon]
            ["@up/base-ui/icons/designer/CallIntentIcon" :default designer--CallIntentIcon]
            ["@up/base-ui/icons/designer/CommentIcon" :default designer--CommentIcon]
            ["@up/base-ui/icons/designer/CompensationIcon" :default designer--CompensationIcon]
            ["@up/base-ui/icons/designer/ConditionalIcon" :default designer--ConditionalIcon]
            ["@up/base-ui/icons/designer/CreateUpdateTicketIcon" :default designer--CreateUpdateTicketIcon]
            ["@up/base-ui/icons/designer/CredentialsIcon" :default designer--CredentialsIcon]
            ["@up/base-ui/icons/designer/CrossBoldIcon" :default designer--CrossBoldIcon]
            ["@up/base-ui/icons/designer/CrossRhombusIcon" :default designer--CrossRhombusIcon]
            ["@up/base-ui/icons/designer/DecipherIcon" :default designer--DecipherIcon]
            ["@up/base-ui/icons/designer/EditVariableIcon" :default designer--EditVariableIcon]
            ["@up/base-ui/icons/designer/EmailFilledIcon" :default designer--EmailFilledIcon]
            ["@up/base-ui/icons/designer/EmailMyIcon" :default designer--EmailMyIcon]
            ["@up/base-ui/icons/designer/EntityIcon" :default designer--EntityIcon]
            ["@up/base-ui/icons/designer/ErrorIcon" :default designer--ErrorIcon]
            ["@up/base-ui/icons/designer/EscalationIcon" :default designer--EscalationIcon]
            ["@up/base-ui/icons/designer/ExclusiveIcon" :default designer--ExclusiveIcon]
            ["@up/base-ui/icons/designer/ExecuteIcon" :default designer--ExecuteIcon]
            ["@up/base-ui/icons/designer/ForkIcon" :default designer--ForkIcon]
            ["@up/base-ui/icons/designer/HostCommandIcon" :default designer--HostCommandIcon]
            ["@up/base-ui/icons/designer/HttpRequestIcon" :default designer--HttpRequestIcon]
            ["@up/base-ui/icons/designer/InclusiveIcon" :default designer--InclusiveIcon]
            ["@up/base-ui/icons/designer/IntentIcon" :default designer--IntentIcon]
            ["@up/base-ui/icons/designer/JoinIcon" :default designer--JoinIcon]
            ["@up/base-ui/icons/designer/JumpToIcon" :default designer--JumpToIcon]
            ["@up/base-ui/icons/designer/LayersIcon" :default designer--LayersIcon]
            ["@up/base-ui/icons/designer/LinkCatchIcon" :default designer--LinkCatchIcon]
            ["@up/base-ui/icons/designer/LinkIcon" :default designer--LinkIcon]
            ["@up/base-ui/icons/designer/LinkThrowIcon" :default designer--LinkThrowIcon]
            ["@up/base-ui/icons/designer/LoopIcon" :default designer--LoopIcon]
            ["@up/base-ui/icons/designer/MailOutlineIcon" :default designer--MailOutlineIcon]
            ["@up/base-ui/icons/designer/MappingIcon" :default designer--MappingIcon]
            ["@up/base-ui/icons/designer/NoopIcon" :default designer--NoopIcon]
            ["@up/base-ui/icons/designer/ObjectIcon" :default designer--ObjectIcon]
            ["@up/base-ui/icons/designer/OneDeskApiIcon" :default designer--OneDeskApiIcon]
            ["@up/base-ui/icons/designer/OntologyIcon" :default designer--OntologyIcon]
            ["@up/base-ui/icons/designer/ParallelIcon" :default designer--ParallelIcon]
            ["@up/base-ui/icons/designer/PresentIcon" :default designer--PresentIcon]
            ["@up/base-ui/icons/designer/RequestDecisionIcon" :default designer--RequestDecisionIcon]
            ["@up/base-ui/icons/designer/RpaIcon" :default designer--RpaIcon]
            ["@up/base-ui/icons/designer/ScriptIcon" :default designer--ScriptIcon]
            ["@up/base-ui/icons/designer/SelectIcon" :default designer--SelectIcon]
            ["@up/base-ui/icons/designer/SignalCatchIcon" :default designer--SignalCatchIcon]
            ["@up/base-ui/icons/designer/SignalThrowIcon" :default designer--SignalThrowIcon]
            ["@up/base-ui/icons/designer/SpeedIcon" :default designer--SpeedIcon]
            ["@up/base-ui/icons/designer/SplitIcon" :default designer--SplitIcon]
            ["@up/base-ui/icons/designer/SubflowIcon" :default designer--SubflowIcon]
            ["@up/base-ui/icons/designer/SuccessIcon" :default designer--SuccessIcon]
            ["@up/base-ui/icons/designer/TerminateIcon" :default designer--TerminateIcon]
            ["@up/base-ui/icons/designer/TicketLifecycleIcon" :default designer--TicketLifecycleIcon]
            ["@up/base-ui/icons/designer/TimeWaitIcon" :default designer--TimeWaitIcon]
            ["@up/base-ui/icons/designer/TransitionIcon" :default designer--TransitionIcon]
            ["@up/base-ui/icons/designer/UserUtteranceIcon" :default designer--UserUtteranceIcon]
            ["@up/base-ui/icons/dialog/AlertIcon" :default dialog--AlertIcon]
            ["@up/base-ui/icons/dialog/BotIcon" :default dialog--BotIcon]
            ["@up/base-ui/icons/dialog/ErrorIcon" :default dialog--ErrorIcon]
            ["@up/base-ui/icons/dialog/FeedbackIcon" :default dialog--FeedbackIcon]
            ["@up/base-ui/icons/dialog/InfoIcon" :default dialog--InfoIcon]
            ["@up/base-ui/icons/dialog/SuccessIcon" :default dialog--SuccessIcon]
            ["@up/base-ui/icons/extra/AmeliaIcon" :default extra--AmeliaIcon]
            ["@up/base-ui/icons/extra/AsrIcon" :default extra--AsrIcon]
            ["@up/base-ui/icons/extra/InteractionsIcon" :default extra--InteractionsIcon]
            ["@up/base-ui/icons/extra/McpIcon" :default extra--McpIcon]
            ["@up/base-ui/icons/extra/ShWavesIcon" :default extra--ShWavesIcon]
            ["@up/base-ui/icons/extra/UipathIcon" :default extra--UipathIcon]
            ["@up/base-ui/icons/promo/PswdChangeIcon" :default promo--PswdChangeIcon]
            ["@up/base-ui/icons/promo/PswdExpiredIcon" :default promo--PswdExpiredIcon]
            ["@up/base-ui/icons/promo/PswdRecoverIcon" :default promo--PswdRecoverIcon]
            ["@up/base-ui/icons/promo/SentIcon" :default promo--SentIcon]
            ["@up/base-ui/icons/promo/TaskActionsIcon" :default promo--TaskActionsIcon]
            ["@up/base-ui/icons/promo/TaskUpdatedIcon" :default promo--TaskUpdatedIcon]
            ["@up/base-ui/icons/promo/UploadIcon" :default promo--UploadIcon]
            ["@up/base-ui/icons/promo/UploadInprogressIcon" :default promo--UploadInprogressIcon]
            ["@up/base-ui/icons/promo/UploadSuccessIcon" :default promo--UploadSuccessIcon]
            ["@up/base-ui/icons/serv/AbandonedRemediationsIcon" :default serv--AbandonedRemediationsIcon]
            ["@up/base-ui/icons/serv/AffectiveMemoryResourcesIcon" :default serv--AffectiveMemoryResourcesIcon]
            ["@up/base-ui/icons/serv/AmeliaIntegrationFrameworkIcon" :default serv--AmeliaIntegrationFrameworkIcon]
            ["@up/base-ui/icons/serv/AnnotationIcon" :default serv--AnnotationIcon]
            ["@up/base-ui/icons/serv/AuditIcon" :default serv--AuditIcon]
            ["@up/base-ui/icons/serv/AuthPolicyIcon" :default serv--AuthPolicyIcon]
            ["@up/base-ui/icons/serv/AutomataIcon" :default serv--AutomataIcon]
            ["@up/base-ui/icons/serv/AvatarIcon" :default serv--AvatarIcon]
            ["@up/base-ui/icons/serv/AvatarVoiceIcon" :default serv--AvatarVoiceIcon]
            ["@up/base-ui/icons/serv/CardsIcon" :default serv--CardsIcon]
            ["@up/base-ui/icons/serv/CertificateIcon" :default serv--CertificateIcon]
            ["@up/base-ui/icons/serv/CognitiveIcon" :default serv--CognitiveIcon]
            ["@up/base-ui/icons/serv/CognitiveProviderIcon" :default serv--CognitiveProviderIcon]
            ["@up/base-ui/icons/serv/CognitiveTaskIcon" :default serv--CognitiveTaskIcon]
            ["@up/base-ui/icons/serv/ConfigurationIcon" :default serv--ConfigurationIcon]
            ["@up/base-ui/icons/serv/ContentManagementIcon" :default serv--ContentManagementIcon]
            ["@up/base-ui/icons/serv/ContentPacksIcon" :default serv--ContentPacksIcon]
            ["@up/base-ui/icons/serv/ConversationAnalyticsIcon" :default serv--ConversationAnalyticsIcon]
            ["@up/base-ui/icons/serv/ConversationIcon" :default serv--ConversationIcon]
            ["@up/base-ui/icons/serv/DebIcon" :default serv--DebIcon]
            ["@up/base-ui/icons/serv/E2eIcon" :default serv--E2eIcon]
            ["@up/base-ui/icons/serv/GatewayIcon" :default serv--GatewayIcon]
            ["@up/base-ui/icons/serv/GrammarIcon" :default serv--GrammarIcon]
            ["@up/base-ui/icons/serv/IpadminIcon" :default serv--IpadminIcon]
            ["@up/base-ui/icons/serv/IpconnectIcon" :default serv--IpconnectIcon]
            ["@up/base-ui/icons/serv/IplogsIcon" :default serv--IplogsIcon]
            ["@up/base-ui/icons/serv/IpradarIcon" :default serv--IpradarIcon]
            ["@up/base-ui/icons/serv/JourneyAnalyticsIcon" :default serv--JourneyAnalyticsIcon]
            ["@up/base-ui/icons/serv/KnowledgeIcon" :default serv--KnowledgeIcon]
            ["@up/base-ui/icons/serv/LogIcon" :default serv--LogIcon]
            ["@up/base-ui/icons/serv/MindIcon" :default serv--MindIcon]
            ["@up/base-ui/icons/serv/ModelIcon" :default serv--ModelIcon]
            ["@up/base-ui/icons/serv/MonitoringIcon" :default serv--MonitoringIcon]
            ["@up/base-ui/icons/serv/NluIcon" :default serv--NluIcon]
            ["@up/base-ui/icons/serv/NpsAnalyticsIcon" :default serv--NpsAnalyticsIcon]
            ["@up/base-ui/icons/serv/OmnyChannelIcon" :default serv--OmnyChannelIcon]
            ["@up/base-ui/icons/serv/OneStoreIcon" :default serv--OneStoreIcon]
            ["@up/base-ui/icons/serv/OrchestratorIcon" :default serv--OrchestratorIcon]
            ["@up/base-ui/icons/serv/PredictIcon" :default serv--PredictIcon]
            ["@up/base-ui/icons/serv/ProcessOptimizationIcon" :default serv--ProcessOptimizationIcon]
            ["@up/base-ui/icons/serv/PropetySetIcon" :default serv--PropetySetIcon]
            ["@up/base-ui/icons/serv/ProxyIcon" :default serv--ProxyIcon]
            ["@up/base-ui/icons/serv/ResponseIcon" :default serv--ResponseIcon]
            ["@up/base-ui/icons/serv/RolesIcon" :default serv--RolesIcon]
            ["@up/base-ui/icons/serv/RouteIcon" :default serv--RouteIcon]
            ["@up/base-ui/icons/serv/SecurityIcon" :default serv--SecurityIcon]
            ["@up/base-ui/icons/serv/TabularDataIcon" :default serv--TabularDataIcon]
            ["@up/base-ui/icons/serv/TeamIcon" :default serv--TeamIcon]
            ["@up/base-ui/icons/serv/UiBundlesIcon" :default serv--UiBundlesIcon]
            ["@up/base-ui/icons/serv/UiIcon" :default serv--UiIcon]
            ["@up/base-ui/icons/serv/UserGroupsIcon" :default serv--UserGroupsIcon]
            ["@up/base-ui/icons/serv/VirtualHostIcon" :default serv--VirtualHostIcon]
            ["@up/base-ui/icons/serv/WebActionIcon" :default serv--WebActionIcon]
            ["@up/base-ui/icons/serv/WorkflowIcon" :default serv--WorkflowIcon]
            ))

(defn material-icon [{:keys [style] :as args}]
  [icon/material-icon (assoc args :style (merge {:color (style/alc-color "Icons/primary")}
                                                style))])

(def up-icons
  {:AIAgentIcon common--AIAgentIcon
   :common/AIAgentIcon common--AIAgentIcon
   :AddBoxIcon common--AddBoxIcon
   :common/AddBoxIcon common--AddBoxIcon
   :AddCircleOutlineIcon common--AddCircleOutlineIcon
   :common/AddCircleOutlineIcon common--AddCircleOutlineIcon
   :AddFromIcon common--AddFromIcon
   :common/AddFromIcon common--AddFromIcon
   :AddIcon common--AddIcon
   :common/AddIcon common--AddIcon
   :AddRhombusIcon common--AddRhombusIcon
   :common/AddRhombusIcon common--AddRhombusIcon
   :AdminIcon common--AdminIcon
   :common/AdminIcon common--AdminIcon
   :AiSummaryIcon common--AiSummaryIcon
   :common/AiSummaryIcon common--AiSummaryIcon
   :common/AlertIcon common--AlertIcon
   :dialog/AlertIcon dialog--AlertIcon
   :AlertIcon common--AlertIcon
   :AnnouncementIcon common--AnnouncementIcon
   :common/AnnouncementIcon common--AnnouncementIcon
   :ArchiveIcon common--ArchiveIcon
   :common/ArchiveIcon common--ArchiveIcon
   :ArrRightAltIcon common--ArrRightAltIcon
   :common/ArrRightAltIcon common--ArrRightAltIcon
   :ArrayIcon common--ArrayIcon
   :common/ArrayIcon common--ArrayIcon
   :ArrowDownIcon common--ArrowDownIcon
   :common/ArrowDownIcon common--ArrowDownIcon
   :ArrowEndIcon common--ArrowEndIcon
   :common/ArrowEndIcon common--ArrowEndIcon
   :ArrowLeftIcon common--ArrowLeftIcon
   :common/ArrowLeftIcon common--ArrowLeftIcon
   :ArrowRightIcon common--ArrowRightIcon
   :common/ArrowRightIcon common--ArrowRightIcon
   :ArrowTopIcon common--ArrowTopIcon
   :common/ArrowTopIcon common--ArrowTopIcon
   :ArrowUpIcon common--ArrowUpIcon
   :common/ArrowUpIcon common--ArrowUpIcon
   :AtIcon common--AtIcon
   :common/AtIcon common--AtIcon
   :AttachFileIcon common--AttachFileIcon
   :common/AttachFileIcon common--AttachFileIcon
   :AttachmentIcon common--AttachmentIcon
   :common/AttachmentIcon common--AttachmentIcon
   :AutolayoutIcon common--AutolayoutIcon
   :common/AutolayoutIcon common--AutolayoutIcon
   :AutomatonIcon common--AutomatonIcon
   :common/AutomatonIcon common--AutomatonIcon
   :BarChartIcon common--BarChartIcon
   :common/BarChartIcon common--BarChartIcon
   :BatchUpdatesIcon common--BatchUpdatesIcon
   :common/BatchUpdatesIcon common--BatchUpdatesIcon
   :BigAddIcon common--BigAddIcon
   :common/BigAddIcon common--BigAddIcon
   :BigEmptyIcon common--BigEmptyIcon
   :common/BigEmptyIcon common--BigEmptyIcon
   :BigErrorIcon common--BigErrorIcon
   :common/BigErrorIcon common--BigErrorIcon
   :BigUploadIcon common--BigUploadIcon
   :common/BigUploadIcon common--BigUploadIcon
   :BlocsIcon common--BlocsIcon
   :common/BlocsIcon common--BlocsIcon
   :BooleanIcon common--BooleanIcon
   :common/BooleanIcon common--BooleanIcon
   :common/BotIcon common--BotIcon
   :dialog/BotIcon dialog--BotIcon
   :BucketIcon common--BucketIcon
   :common/BucketIcon common--BucketIcon
   :BugReportIcon common--BugReportIcon
   :common/BugReportIcon common--BugReportIcon
   :BulkIcon common--BulkIcon
   :common/BulkIcon common--BulkIcon
   :BurgerMenuIcon common--BurgerMenuIcon
   :common/BurgerMenuIcon common--BurgerMenuIcon
   :CalendarIcon common--CalendarIcon
   :common/CalendarIcon common--CalendarIcon
   :CallEndIcon common--CallEndIcon
   :common/CallEndIcon common--CallEndIcon
   :CallIcon common--CallIcon
   :common/CallIcon common--CallIcon
   :CallMissedIcon common--CallMissedIcon
   :common/CallMissedIcon common--CallMissedIcon
   :CallbackIcon common--CallbackIcon
   :common/CallbackIcon common--CallbackIcon
   :ChangeUserIcon common--ChangeUserIcon
   :common/ChangeUserIcon common--ChangeUserIcon
   :ChatIcon common--ChatIcon
   :common/ChatIcon common--ChatIcon
   :CheckCircleIcon common--CheckCircleIcon
   :common/CheckCircleIcon common--CheckCircleIcon
   :CheckSquareIcon common--CheckSquareIcon
   :common/CheckSquareIcon common--CheckSquareIcon
   :ChevronDownIcon common--ChevronDownIcon
   :common/ChevronDownIcon common--ChevronDownIcon
   :ChevronLeftIcon common--ChevronLeftIcon
   :common/ChevronLeftIcon common--ChevronLeftIcon
   :ChevronRightIcon common--ChevronRightIcon
   :common/ChevronRightIcon common--ChevronRightIcon
   :ChevronTopIcon common--ChevronTopIcon
   :common/ChevronTopIcon common--ChevronTopIcon
   :CityIcon common--CityIcon
   :common/CityIcon common--CityIcon
   :CleanIcon common--CleanIcon
   :common/CleanIcon common--CleanIcon
   :ClientIcon common--ClientIcon
   :common/ClientIcon common--ClientIcon
   :CloneIcon common--CloneIcon
   :common/CloneIcon common--CloneIcon
   :CloudOffIcon common--CloudOffIcon
   :common/CloudOffIcon common--CloudOffIcon
   :CloudSyncIcon common--CloudSyncIcon
   :common/CloudSyncIcon common--CloudSyncIcon
   :CloudUploadedIcon common--CloudUploadedIcon
   :common/CloudUploadedIcon common--CloudUploadedIcon
   :CodeIcon common--CodeIcon
   :common/CodeIcon common--CodeIcon
   :CompressVertIcon common--CompressVertIcon
   :common/CompressVertIcon common--CompressVertIcon
   :CopyIcon common--CopyIcon
   :common/CopyIcon common--CopyIcon
   :CreateNewFolderIcon common--CreateNewFolderIcon
   :common/CreateNewFolderIcon common--CreateNewFolderIcon
   :CrossCircleIcon common--CrossCircleIcon
   :common/CrossCircleIcon common--CrossCircleIcon
   :CrossIcon common--CrossIcon
   :common/CrossIcon common--CrossIcon
   :CutContentIcon common--CutContentIcon
   :common/CutContentIcon common--CutContentIcon
   :CutIcon common--CutIcon
   :common/CutIcon common--CutIcon
   :DarkModeIcon common--DarkModeIcon
   :common/DarkModeIcon common--DarkModeIcon
   :DeadlineIcon common--DeadlineIcon
   :common/DeadlineIcon common--DeadlineIcon
   :DeleteBasketIcon common--DeleteBasketIcon
   :common/DeleteBasketIcon common--DeleteBasketIcon
   :DeleteIcon common--DeleteIcon
   :common/DeleteIcon common--DeleteIcon
   :DialpadIcon common--DialpadIcon
   :common/DialpadIcon common--DialpadIcon
   :DisableIcon common--DisableIcon
   :common/DisableIcon common--DisableIcon
   :DislikeIcon common--DislikeIcon
   :common/DislikeIcon common--DislikeIcon
   :DocIcon common--DocIcon
   :common/DocIcon common--DocIcon
   :DoneIcon common--DoneIcon
   :common/DoneIcon common--DoneIcon
   :DotIndicatorIcon common--DotIndicatorIcon
   :common/DotIndicatorIcon common--DotIndicatorIcon
   :DoubleChevronLeftIcon common--DoubleChevronLeftIcon
   :common/DoubleChevronLeftIcon common--DoubleChevronLeftIcon
   :DoubleChevronRightIcon common--DoubleChevronRightIcon
   :common/DoubleChevronRightIcon common--DoubleChevronRightIcon
   :DownloadIcon common--DownloadIcon
   :common/DownloadIcon common--DownloadIcon
   :DowntimeIcon common--DowntimeIcon
   :common/DowntimeIcon common--DowntimeIcon
   :DragIcon common--DragIcon
   :common/DragIcon common--DragIcon
   :EditIcon common--EditIcon
   :common/EditIcon common--EditIcon
   :EditTextIcon common--EditTextIcon
   :common/EditTextIcon common--EditTextIcon
   :EmojiAverageIcon common--EmojiAverageIcon
   :common/EmojiAverageIcon common--EmojiAverageIcon
   :EmojiBadIcon common--EmojiBadIcon
   :common/EmojiBadIcon common--EmojiBadIcon
   :EmojiExcellentIcon common--EmojiExcellentIcon
   :common/EmojiExcellentIcon common--EmojiExcellentIcon
   :EmojiGoodIcon common--EmojiGoodIcon
   :common/EmojiGoodIcon common--EmojiGoodIcon
   :EmojiPoorIcon common--EmojiPoorIcon
   :common/EmojiPoorIcon common--EmojiPoorIcon
   :EventIcon common--EventIcon
   :common/EventIcon common--EventIcon
   :EventManagementIcon common--EventManagementIcon
   :common/EventManagementIcon common--EventManagementIcon
   :ExitAllContextIcon common--ExitAllContextIcon
   :common/ExitAllContextIcon common--ExitAllContextIcon
   :ExitContextIcon common--ExitContextIcon
   :common/ExitContextIcon common--ExitContextIcon
   :ExitIcon common--ExitIcon
   :common/ExitIcon common--ExitIcon
   :ExpandInputIcon common--ExpandInputIcon
   :common/ExpandInputIcon common--ExpandInputIcon
   :ExpandVertIcon common--ExpandVertIcon
   :common/ExpandVertIcon common--ExpandVertIcon
   :ExportIcon common--ExportIcon
   :common/ExportIcon common--ExportIcon
   :ExternalProvidersIcon common--ExternalProvidersIcon
   :common/ExternalProvidersIcon common--ExternalProvidersIcon
   :FaceScanIcon common--FaceScanIcon
   :common/FaceScanIcon common--FaceScanIcon
   :FallbackIcon common--FallbackIcon
   :common/FallbackIcon common--FallbackIcon
   :common/FeedbackIcon common--FeedbackIcon
   :dialog/FeedbackIcon dialog--FeedbackIcon
   :FileCopyIcon common--FileCopyIcon
   :common/FileCopyIcon common--FileCopyIcon
   :FileExcelIcon common--FileExcelIcon
   :common/FileExcelIcon common--FileExcelIcon
   :FilePdfIcon common--FilePdfIcon
   :common/FilePdfIcon common--FilePdfIcon
   :FilePresentationIcon common--FilePresentationIcon
   :common/FilePresentationIcon common--FilePresentationIcon
   :FileWordIcon common--FileWordIcon
   :common/FileWordIcon common--FileWordIcon
   :FilterIcon common--FilterIcon
   :common/FilterIcon common--FilterIcon
   :FirstIcon common--FirstIcon
   :common/FirstIcon common--FirstIcon
   :FitToSizeIcon common--FitToSizeIcon
   :common/FitToSizeIcon common--FitToSizeIcon
   :FolderIcon common--FolderIcon
   :common/FolderIcon common--FolderIcon
   :FolderOpenIcon common--FolderOpenIcon
   :common/FolderOpenIcon common--FolderOpenIcon
   :FontcolorIcon common--FontcolorIcon
   :common/FontcolorIcon common--FontcolorIcon
   :FunctionIcon common--FunctionIcon
   :common/FunctionIcon common--FunctionIcon
   :GenerateIcon common--GenerateIcon
   :common/GenerateIcon common--GenerateIcon
   :HelpFilledIcon common--HelpFilledIcon
   :common/HelpFilledIcon common--HelpFilledIcon
   :HelpIcon common--HelpIcon
   :common/HelpIcon common--HelpIcon
   :HideIcon common--HideIcon
   :common/HideIcon common--HideIcon
   :HistoryIcon common--HistoryIcon
   :common/HistoryIcon common--HistoryIcon
   :HomeIcon common--HomeIcon
   :common/HomeIcon common--HomeIcon
   :HyperaFlightIcon common--HyperaFlightIcon
   :common/HyperaFlightIcon common--HyperaFlightIcon
   :HyperaLandIcon common--HyperaLandIcon
   :common/HyperaLandIcon common--HyperaLandIcon
   :HyperaTakeoffIcon common--HyperaTakeoffIcon
   :common/HyperaTakeoffIcon common--HyperaTakeoffIcon
   :ImageIcon common--ImageIcon
   :common/ImageIcon common--ImageIcon
   :ImportIcon common--ImportIcon
   :common/ImportIcon common--ImportIcon
   :IndexQueuedIcon common--IndexQueuedIcon
   :common/IndexQueuedIcon common--IndexQueuedIcon
   :IndexingIcon common--IndexingIcon
   :common/IndexingIcon common--IndexingIcon
   :common/InfoIcon common--InfoIcon
   :dialog/InfoIcon dialog--InfoIcon
   :InputIcon common--InputIcon
   :common/InputIcon common--InputIcon
   :IntegerIcon common--IntegerIcon
   :common/IntegerIcon common--IntegerIcon
   :KebabMenuHorzIcon common--KebabMenuHorzIcon
   :common/KebabMenuHorzIcon common--KebabMenuHorzIcon
   :KebabMenuVertIcon common--KebabMenuVertIcon
   :common/KebabMenuVertIcon common--KebabMenuVertIcon
   :LaptopIcon common--LaptopIcon
   :common/LaptopIcon common--LaptopIcon
   :LastIcon common--LastIcon
   :common/LastIcon common--LastIcon
   :Layout1HorIcon common--Layout1HorIcon
   :common/Layout1HorIcon common--Layout1HorIcon
   :Layout1VerIcon common--Layout1VerIcon
   :common/Layout1VerIcon common--Layout1VerIcon
   :Layout2HorIcon common--Layout2HorIcon
   :common/Layout2HorIcon common--Layout2HorIcon
   :LearnIcon common--LearnIcon
   :common/LearnIcon common--LearnIcon
   :LevelUpIcon common--LevelUpIcon
   :common/LevelUpIcon common--LevelUpIcon
   :LightModeIcon common--LightModeIcon
   :common/LightModeIcon common--LightModeIcon
   :LikeIcon common--LikeIcon
   :common/LikeIcon common--LikeIcon
   :common/LinkIcon common--LinkIcon
   :designer/LinkIcon designer--LinkIcon
   :LocationIcon common--LocationIcon
   :common/LocationIcon common--LocationIcon
   :LookupIcon common--LookupIcon
   :common/LookupIcon common--LookupIcon
   :Magic2Icon common--Magic2Icon
   :common/Magic2Icon common--Magic2Icon
   :MagicIcon common--MagicIcon
   :common/MagicIcon common--MagicIcon
   :MicIcon common--MicIcon
   :common/MicIcon common--MicIcon
   :MicOffIcon common--MicOffIcon
   :common/MicOffIcon common--MicOffIcon
   :MinimizeIcon common--MinimizeIcon
   :common/MinimizeIcon common--MinimizeIcon
   :MobilePhoneIcon common--MobilePhoneIcon
   :common/MobilePhoneIcon common--MobilePhoneIcon
   :MoreSettingsIcon common--MoreSettingsIcon
   :common/MoreSettingsIcon common--MoreSettingsIcon
   :NoImageIcon common--NoImageIcon
   :common/NoImageIcon common--NoImageIcon
   :NotSignedIcon common--NotSignedIcon
   :common/NotSignedIcon common--NotSignedIcon
   :NotifyIcon common--NotifyIcon
   :common/NotifyIcon common--NotifyIcon
   :common/ObjectIcon common--ObjectIcon
   :designer/ObjectIcon designer--ObjectIcon
   :OpenInNewIcon common--OpenInNewIcon
   :common/OpenInNewIcon common--OpenInNewIcon
   :OsWindowIcon common--OsWindowIcon
   :common/OsWindowIcon common--OsWindowIcon
   :OutputIcon common--OutputIcon
   :common/OutputIcon common--OutputIcon
   :PartialDoneIcon common--PartialDoneIcon
   :common/PartialDoneIcon common--PartialDoneIcon
   :PasswordIcon common--PasswordIcon
   :common/PasswordIcon common--PasswordIcon
   :PasteIcon common--PasteIcon
   :common/PasteIcon common--PasteIcon
   :PauseIcon common--PauseIcon
   :common/PauseIcon common--PauseIcon
   :PhonebookIcon common--PhonebookIcon
   :common/PhonebookIcon common--PhonebookIcon
   :PhotoIcon common--PhotoIcon
   :common/PhotoIcon common--PhotoIcon
   :PinIcon common--PinIcon
   :common/PinIcon common--PinIcon
   :PinnedIcon common--PinnedIcon
   :common/PinnedIcon common--PinnedIcon
   :PlayIcon common--PlayIcon
   :common/PlayIcon common--PlayIcon
   :PriorityIcon common--PriorityIcon
   :common/PriorityIcon common--PriorityIcon
   :ProcessingFaqIcon common--ProcessingFaqIcon
   :common/ProcessingFaqIcon common--ProcessingFaqIcon
   :ProcessingSegmentsIcon common--ProcessingSegmentsIcon
   :common/ProcessingSegmentsIcon common--ProcessingSegmentsIcon
   :Properties2Icon common--Properties2Icon
   :common/Properties2Icon common--Properties2Icon
   :PropertiesIcon common--PropertiesIcon
   :common/PropertiesIcon common--PropertiesIcon
   :ProtectedIcon common--ProtectedIcon
   :common/ProtectedIcon common--ProtectedIcon
   :PublishIcon common--PublishIcon
   :common/PublishIcon common--PublishIcon
   :PuzzleIcon common--PuzzleIcon
   :common/PuzzleIcon common--PuzzleIcon
   :PuzzleTemplateIcon common--PuzzleTemplateIcon
   :common/PuzzleTemplateIcon common--PuzzleTemplateIcon
   :QuestionmarkCircleIcon common--QuestionmarkCircleIcon
   :common/QuestionmarkCircleIcon common--QuestionmarkCircleIcon
   :QueueIcon common--QueueIcon
   :common/QueueIcon common--QueueIcon
   :RedoIcon common--RedoIcon
   :common/RedoIcon common--RedoIcon
   :RefreshIcon common--RefreshIcon
   :common/RefreshIcon common--RefreshIcon
   :RemoveCircleIcon common--RemoveCircleIcon
   :common/RemoveCircleIcon common--RemoveCircleIcon
   :RemoveIcon common--RemoveIcon
   :common/RemoveIcon common--RemoveIcon
   :RenewIcon common--RenewIcon
   :common/RenewIcon common--RenewIcon
   :ReplaceIcon common--ReplaceIcon
   :common/ReplaceIcon common--ReplaceIcon
   :RevisionIcon common--RevisionIcon
   :common/RevisionIcon common--RevisionIcon
   :RingVolumeIcon common--RingVolumeIcon
   :common/RingVolumeIcon common--RingVolumeIcon
   :RocketIcon common--RocketIcon
   :common/RocketIcon common--RocketIcon
   :RulesIcon common--RulesIcon
   :common/RulesIcon common--RulesIcon
   :SaveAltIcon common--SaveAltIcon
   :common/SaveAltIcon common--SaveAltIcon
   :SaveIcon common--SaveIcon
   :common/SaveIcon common--SaveIcon
   :SaveVersionIcon common--SaveVersionIcon
   :common/SaveVersionIcon common--SaveVersionIcon
   :SearchIcon common--SearchIcon
   :common/SearchIcon common--SearchIcon
   :SearchNotFoundIcon common--SearchNotFoundIcon
   :common/SearchNotFoundIcon common--SearchNotFoundIcon
   :SegmentsQueuedIcon common--SegmentsQueuedIcon
   :common/SegmentsQueuedIcon common--SegmentsQueuedIcon
   :SendIcon common--SendIcon
   :common/SendIcon common--SendIcon
   :SessionIcon common--SessionIcon
   :common/SessionIcon common--SessionIcon
   :Settings2Icon common--Settings2Icon
   :common/Settings2Icon common--Settings2Icon
   :SettingsIcon common--SettingsIcon
   :common/SettingsIcon common--SettingsIcon
   :ShiftIcon common--ShiftIcon
   :common/ShiftIcon common--ShiftIcon
   :ShowIcon common--ShowIcon
   :common/ShowIcon common--ShowIcon
   :SidebarLIcon common--SidebarLIcon
   :common/SidebarLIcon common--SidebarLIcon
   :SidebarRIcon common--SidebarRIcon
   :common/SidebarRIcon common--SidebarRIcon
   :SignedIcon common--SignedIcon
   :common/SignedIcon common--SignedIcon
   :SlaIcon common--SlaIcon
   :common/SlaIcon common--SlaIcon
   :SmallChevroneIcon common--SmallChevroneIcon
   :common/SmallChevroneIcon common--SmallChevroneIcon
   :StarBorderIcon common--StarBorderIcon
   :common/StarBorderIcon common--StarBorderIcon
   :StarIcon common--StarIcon
   :common/StarIcon common--StarIcon
   :StopIcon common--StopIcon
   :common/StopIcon common--StopIcon
   :StrikethroughIcon common--StrikethroughIcon
   :common/StrikethroughIcon common--StrikethroughIcon
   :StringIcon common--StringIcon
   :common/StringIcon common--StringIcon
   :SubLevelIcon common--SubLevelIcon
   :common/SubLevelIcon common--SubLevelIcon
   :SubscribeIcon common--SubscribeIcon
   :common/SubscribeIcon common--SubscribeIcon
   :SubscribedIcon common--SubscribedIcon
   :common/SubscribedIcon common--SubscribedIcon
   :SupportIcon common--SupportIcon
   :common/SupportIcon common--SupportIcon
   :TagsIcon common--TagsIcon
   :common/TagsIcon common--TagsIcon
   :TasksIcon common--TasksIcon
   :common/TasksIcon common--TasksIcon
   :TemplateIcon common--TemplateIcon
   :common/TemplateIcon common--TemplateIcon
   :ThemeIcon common--ThemeIcon
   :common/ThemeIcon common--ThemeIcon
   :TilesMenuIcon common--TilesMenuIcon
   :common/TilesMenuIcon common--TilesMenuIcon
   :TimeFilledIcon common--TimeFilledIcon
   :common/TimeFilledIcon common--TimeFilledIcon
   :TimeIcon common--TimeIcon
   :common/TimeIcon common--TimeIcon
   :TokenIcon common--TokenIcon
   :common/TokenIcon common--TokenIcon
   :TransferIcon common--TransferIcon
   :common/TransferIcon common--TransferIcon
   :TranslateIcon common--TranslateIcon
   :common/TranslateIcon common--TranslateIcon
   :TreeIcon common--TreeIcon
   :common/TreeIcon common--TreeIcon
   :TxtBoldIcon common--TxtBoldIcon
   :common/TxtBoldIcon common--TxtBoldIcon
   :TxtH1Icon common--TxtH1Icon
   :common/TxtH1Icon common--TxtH1Icon
   :TxtH2Icon common--TxtH2Icon
   :common/TxtH2Icon common--TxtH2Icon
   :TxtH3Icon common--TxtH3Icon
   :common/TxtH3Icon common--TxtH3Icon
   :TxtH4Icon common--TxtH4Icon
   :common/TxtH4Icon common--TxtH4Icon
   :TxtH5Icon common--TxtH5Icon
   :common/TxtH5Icon common--TxtH5Icon
   :TxtH6Icon common--TxtH6Icon
   :common/TxtH6Icon common--TxtH6Icon
   :TxtItalicIcon common--TxtItalicIcon
   :common/TxtItalicIcon common--TxtItalicIcon
   :TxtListBulletedIcon common--TxtListBulletedIcon
   :common/TxtListBulletedIcon common--TxtListBulletedIcon
   :TxtListNumberedIcon common--TxtListNumberedIcon
   :common/TxtListNumberedIcon common--TxtListNumberedIcon
   :TxtQuoteIcon common--TxtQuoteIcon
   :common/TxtQuoteIcon common--TxtQuoteIcon
   :TxtStrikethroughIcon common--TxtStrikethroughIcon
   :common/TxtStrikethroughIcon common--TxtStrikethroughIcon
   :TxtUnderlinedIcon common--TxtUnderlinedIcon
   :common/TxtUnderlinedIcon common--TxtUnderlinedIcon
   :UndoIcon common--UndoIcon
   :common/UndoIcon common--UndoIcon
   :UnlinkIcon common--UnlinkIcon
   :common/UnlinkIcon common--UnlinkIcon
   :UpdatedIcon common--UpdatedIcon
   :common/UpdatedIcon common--UpdatedIcon
   :UpgradeIcon common--UpgradeIcon
   :common/UpgradeIcon common--UpgradeIcon
   :common/UploadIcon common--UploadIcon
   :promo/UploadIcon promo--UploadIcon
   :UroutedIcon common--UroutedIcon
   :common/UroutedIcon common--UroutedIcon
   :UserAvaIcon common--UserAvaIcon
   :common/UserAvaIcon common--UserAvaIcon
   :UserCaseIcon common--UserCaseIcon
   :common/UserCaseIcon common--UserCaseIcon
   :UserIcon common--UserIcon
   :common/UserIcon common--UserIcon
   :UserOutlineIcon common--UserOutlineIcon
   :common/UserOutlineIcon common--UserOutlineIcon
   :UserProtectionIcon common--UserProtectionIcon
   :common/UserProtectionIcon common--UserProtectionIcon
   :UsersDispatchIcon common--UsersDispatchIcon
   :common/UsersDispatchIcon common--UsersDispatchIcon
   :VideoembedIcon common--VideoembedIcon
   :common/VideoembedIcon common--VideoembedIcon
   :VocabularyIcon common--VocabularyIcon
   :common/VocabularyIcon common--VocabularyIcon
   :VoiceChatIcon common--VoiceChatIcon
   :common/VoiceChatIcon common--VoiceChatIcon
   :VolumeOffIcon common--VolumeOffIcon
   :common/VolumeOffIcon common--VolumeOffIcon
   :VolumeOnIcon common--VolumeOnIcon
   :common/VolumeOnIcon common--VolumeOnIcon
   :WarningIcon common--WarningIcon
   :common/WarningIcon common--WarningIcon
   :WebIcon common--WebIcon
   :common/WebIcon common--WebIcon
   :WebhookIcon common--WebhookIcon
   :common/WebhookIcon common--WebhookIcon
   :ZoomExpandIcon common--ZoomExpandIcon
   :common/ZoomExpandIcon common--ZoomExpandIcon
   :ZoomInIcon common--ZoomInIcon
   :common/ZoomInIcon common--ZoomInIcon
   :ZoomOutIcon common--ZoomOutIcon
   :common/ZoomOutIcon common--ZoomOutIcon
   :ActionIcon designer--ActionIcon
   :designer/ActionIcon designer--ActionIcon
   :AiopsIcon designer--AiopsIcon
   :designer/AiopsIcon designer--AiopsIcon
   :AlarmIcon designer--AlarmIcon
   :designer/AlarmIcon designer--AlarmIcon
   :AmeliaAsksIcon designer--AmeliaAsksIcon
   :designer/AmeliaAsksIcon designer--AmeliaAsksIcon
   :AmeliaSaysIcon designer--AmeliaSaysIcon
   :designer/AmeliaSaysIcon designer--AmeliaSaysIcon
   :BulbIcon designer--BulbIcon
   :designer/BulbIcon designer--BulbIcon
   :CallIntentIcon designer--CallIntentIcon
   :designer/CallIntentIcon designer--CallIntentIcon
   :CommentIcon designer--CommentIcon
   :designer/CommentIcon designer--CommentIcon
   :CompensationIcon designer--CompensationIcon
   :designer/CompensationIcon designer--CompensationIcon
   :ConditionalIcon designer--ConditionalIcon
   :designer/ConditionalIcon designer--ConditionalIcon
   :CreateUpdateTicketIcon designer--CreateUpdateTicketIcon
   :designer/CreateUpdateTicketIcon designer--CreateUpdateTicketIcon
   :CredentialsIcon designer--CredentialsIcon
   :designer/CredentialsIcon designer--CredentialsIcon
   :CrossBoldIcon designer--CrossBoldIcon
   :designer/CrossBoldIcon designer--CrossBoldIcon
   :CrossRhombusIcon designer--CrossRhombusIcon
   :designer/CrossRhombusIcon designer--CrossRhombusIcon
   :DecipherIcon designer--DecipherIcon
   :designer/DecipherIcon designer--DecipherIcon
   :EditVariableIcon designer--EditVariableIcon
   :designer/EditVariableIcon designer--EditVariableIcon
   :EmailFilledIcon designer--EmailFilledIcon
   :designer/EmailFilledIcon designer--EmailFilledIcon
   :EmailMyIcon designer--EmailMyIcon
   :designer/EmailMyIcon designer--EmailMyIcon
   :EntityIcon designer--EntityIcon
   :designer/EntityIcon designer--EntityIcon
   :designer/ErrorIcon designer--ErrorIcon
   :dialog/ErrorIcon dialog--ErrorIcon
   :EscalationIcon designer--EscalationIcon
   :designer/EscalationIcon designer--EscalationIcon
   :ExclusiveIcon designer--ExclusiveIcon
   :designer/ExclusiveIcon designer--ExclusiveIcon
   :ExecuteIcon designer--ExecuteIcon
   :designer/ExecuteIcon designer--ExecuteIcon
   :ForkIcon designer--ForkIcon
   :designer/ForkIcon designer--ForkIcon
   :HostCommandIcon designer--HostCommandIcon
   :designer/HostCommandIcon designer--HostCommandIcon
   :HttpRequestIcon designer--HttpRequestIcon
   :designer/HttpRequestIcon designer--HttpRequestIcon
   :InclusiveIcon designer--InclusiveIcon
   :designer/InclusiveIcon designer--InclusiveIcon
   :IntentIcon designer--IntentIcon
   :designer/IntentIcon designer--IntentIcon
   :JoinIcon designer--JoinIcon
   :designer/JoinIcon designer--JoinIcon
   :JumpToIcon designer--JumpToIcon
   :designer/JumpToIcon designer--JumpToIcon
   :LayersIcon designer--LayersIcon
   :designer/LayersIcon designer--LayersIcon
   :LinkCatchIcon designer--LinkCatchIcon
   :designer/LinkCatchIcon designer--LinkCatchIcon
   :LinkThrowIcon designer--LinkThrowIcon
   :designer/LinkThrowIcon designer--LinkThrowIcon
   :LoopIcon designer--LoopIcon
   :designer/LoopIcon designer--LoopIcon
   :MailOutlineIcon designer--MailOutlineIcon
   :designer/MailOutlineIcon designer--MailOutlineIcon
   :MappingIcon designer--MappingIcon
   :designer/MappingIcon designer--MappingIcon
   :NoopIcon designer--NoopIcon
   :designer/NoopIcon designer--NoopIcon
   :OneDeskApiIcon designer--OneDeskApiIcon
   :designer/OneDeskApiIcon designer--OneDeskApiIcon
   :OntologyIcon designer--OntologyIcon
   :designer/OntologyIcon designer--OntologyIcon
   :ParallelIcon designer--ParallelIcon
   :designer/ParallelIcon designer--ParallelIcon
   :PresentIcon designer--PresentIcon
   :designer/PresentIcon designer--PresentIcon
   :RequestDecisionIcon designer--RequestDecisionIcon
   :designer/RequestDecisionIcon designer--RequestDecisionIcon
   :RpaIcon designer--RpaIcon
   :designer/RpaIcon designer--RpaIcon
   :ScriptIcon designer--ScriptIcon
   :designer/ScriptIcon designer--ScriptIcon
   :SelectIcon designer--SelectIcon
   :designer/SelectIcon designer--SelectIcon
   :SignalCatchIcon designer--SignalCatchIcon
   :designer/SignalCatchIcon designer--SignalCatchIcon
   :SignalThrowIcon designer--SignalThrowIcon
   :designer/SignalThrowIcon designer--SignalThrowIcon
   :SpeedIcon designer--SpeedIcon
   :designer/SpeedIcon designer--SpeedIcon
   :SplitIcon designer--SplitIcon
   :designer/SplitIcon designer--SplitIcon
   :SubflowIcon designer--SubflowIcon
   :designer/SubflowIcon designer--SubflowIcon
   :designer/SuccessIcon designer--SuccessIcon
   :dialog/SuccessIcon dialog--SuccessIcon
   :TerminateIcon designer--TerminateIcon
   :designer/TerminateIcon designer--TerminateIcon
   :TicketLifecycleIcon designer--TicketLifecycleIcon
   :designer/TicketLifecycleIcon designer--TicketLifecycleIcon
   :TimeWaitIcon designer--TimeWaitIcon
   :designer/TimeWaitIcon designer--TimeWaitIcon
   :TransitionIcon designer--TransitionIcon
   :designer/TransitionIcon designer--TransitionIcon
   :UserUtteranceIcon designer--UserUtteranceIcon
   :designer/UserUtteranceIcon designer--UserUtteranceIcon
   :AmeliaIcon extra--AmeliaIcon
   :extra/AmeliaIcon extra--AmeliaIcon
   :AsrIcon extra--AsrIcon
   :extra/AsrIcon extra--AsrIcon
   :InteractionsIcon extra--InteractionsIcon
   :extra/InteractionsIcon extra--InteractionsIcon
   :McpIcon extra--McpIcon
   :extra/McpIcon extra--McpIcon
   :ShWavesIcon extra--ShWavesIcon
   :extra/ShWavesIcon extra--ShWavesIcon
   :UipathIcon extra--UipathIcon
   :extra/UipathIcon extra--UipathIcon
   :PswdChangeIcon promo--PswdChangeIcon
   :promo/PswdChangeIcon promo--PswdChangeIcon
   :PswdExpiredIcon promo--PswdExpiredIcon
   :promo/PswdExpiredIcon promo--PswdExpiredIcon
   :PswdRecoverIcon promo--PswdRecoverIcon
   :promo/PswdRecoverIcon promo--PswdRecoverIcon
   :SentIcon promo--SentIcon
   :promo/SentIcon promo--SentIcon
   :TaskActionsIcon promo--TaskActionsIcon
   :promo/TaskActionsIcon promo--TaskActionsIcon
   :TaskUpdatedIcon promo--TaskUpdatedIcon
   :promo/TaskUpdatedIcon promo--TaskUpdatedIcon
   :UploadInprogressIcon promo--UploadInprogressIcon
   :promo/UploadInprogressIcon promo--UploadInprogressIcon
   :UploadSuccessIcon promo--UploadSuccessIcon
   :promo/UploadSuccessIcon promo--UploadSuccessIcon
   :AbandonedRemediationsIcon serv--AbandonedRemediationsIcon
   :serv/AbandonedRemediationsIcon serv--AbandonedRemediationsIcon
   :AffectiveMemoryResourcesIcon serv--AffectiveMemoryResourcesIcon
   :serv/AffectiveMemoryResourcesIcon serv--AffectiveMemoryResourcesIcon
   :AmeliaIntegrationFrameworkIcon serv--AmeliaIntegrationFrameworkIcon
   :serv/AmeliaIntegrationFrameworkIcon serv--AmeliaIntegrationFrameworkIcon
   :AnnotationIcon serv--AnnotationIcon
   :serv/AnnotationIcon serv--AnnotationIcon
   :AuditIcon serv--AuditIcon
   :serv/AuditIcon serv--AuditIcon
   :AuthPolicyIcon serv--AuthPolicyIcon
   :serv/AuthPolicyIcon serv--AuthPolicyIcon
   :AutomataIcon serv--AutomataIcon
   :serv/AutomataIcon serv--AutomataIcon
   :AvatarIcon serv--AvatarIcon
   :serv/AvatarIcon serv--AvatarIcon
   :AvatarVoiceIcon serv--AvatarVoiceIcon
   :serv/AvatarVoiceIcon serv--AvatarVoiceIcon
   :CardsIcon serv--CardsIcon
   :serv/CardsIcon serv--CardsIcon
   :CertificateIcon serv--CertificateIcon
   :serv/CertificateIcon serv--CertificateIcon
   :CognitiveIcon serv--CognitiveIcon
   :serv/CognitiveIcon serv--CognitiveIcon
   :CognitiveProviderIcon serv--CognitiveProviderIcon
   :serv/CognitiveProviderIcon serv--CognitiveProviderIcon
   :CognitiveTaskIcon serv--CognitiveTaskIcon
   :serv/CognitiveTaskIcon serv--CognitiveTaskIcon
   :ConfigurationIcon serv--ConfigurationIcon
   :serv/ConfigurationIcon serv--ConfigurationIcon
   :ContentManagementIcon serv--ContentManagementIcon
   :serv/ContentManagementIcon serv--ContentManagementIcon
   :ContentPacksIcon serv--ContentPacksIcon
   :serv/ContentPacksIcon serv--ContentPacksIcon
   :ConversationAnalyticsIcon serv--ConversationAnalyticsIcon
   :serv/ConversationAnalyticsIcon serv--ConversationAnalyticsIcon
   :ConversationIcon serv--ConversationIcon
   :serv/ConversationIcon serv--ConversationIcon
   :DebIcon serv--DebIcon
   :serv/DebIcon serv--DebIcon
   :E2eIcon serv--E2eIcon
   :serv/E2eIcon serv--E2eIcon
   :GatewayIcon serv--GatewayIcon
   :serv/GatewayIcon serv--GatewayIcon
   :GrammarIcon serv--GrammarIcon
   :serv/GrammarIcon serv--GrammarIcon
   :IpadminIcon serv--IpadminIcon
   :serv/IpadminIcon serv--IpadminIcon
   :IpconnectIcon serv--IpconnectIcon
   :serv/IpconnectIcon serv--IpconnectIcon
   :IplogsIcon serv--IplogsIcon
   :serv/IplogsIcon serv--IplogsIcon
   :IpradarIcon serv--IpradarIcon
   :serv/IpradarIcon serv--IpradarIcon
   :JourneyAnalyticsIcon serv--JourneyAnalyticsIcon
   :serv/JourneyAnalyticsIcon serv--JourneyAnalyticsIcon
   :KnowledgeIcon serv--KnowledgeIcon
   :serv/KnowledgeIcon serv--KnowledgeIcon
   :LogIcon serv--LogIcon
   :serv/LogIcon serv--LogIcon
   :MindIcon serv--MindIcon
   :serv/MindIcon serv--MindIcon
   :ModelIcon serv--ModelIcon
   :serv/ModelIcon serv--ModelIcon
   :MonitoringIcon serv--MonitoringIcon
   :serv/MonitoringIcon serv--MonitoringIcon
   :NluIcon serv--NluIcon
   :serv/NluIcon serv--NluIcon
   :NpsAnalyticsIcon serv--NpsAnalyticsIcon
   :serv/NpsAnalyticsIcon serv--NpsAnalyticsIcon
   :OmnyChannelIcon serv--OmnyChannelIcon
   :serv/OmnyChannelIcon serv--OmnyChannelIcon
   :OneStoreIcon serv--OneStoreIcon
   :serv/OneStoreIcon serv--OneStoreIcon
   :OrchestratorIcon serv--OrchestratorIcon
   :serv/OrchestratorIcon serv--OrchestratorIcon
   :PredictIcon serv--PredictIcon
   :serv/PredictIcon serv--PredictIcon
   :ProcessOptimizationIcon serv--ProcessOptimizationIcon
   :serv/ProcessOptimizationIcon serv--ProcessOptimizationIcon
   :PropetySetIcon serv--PropetySetIcon
   :serv/PropetySetIcon serv--PropetySetIcon
   :ProxyIcon serv--ProxyIcon
   :serv/ProxyIcon serv--ProxyIcon
   :ResponseIcon serv--ResponseIcon
   :serv/ResponseIcon serv--ResponseIcon
   :RolesIcon serv--RolesIcon
   :serv/RolesIcon serv--RolesIcon
   :RouteIcon serv--RouteIcon
   :serv/RouteIcon serv--RouteIcon
   :SecurityIcon serv--SecurityIcon
   :serv/SecurityIcon serv--SecurityIcon
   :TabularDataIcon serv--TabularDataIcon
   :serv/TabularDataIcon serv--TabularDataIcon
   :TeamIcon serv--TeamIcon
   :serv/TeamIcon serv--TeamIcon
   :UiBundlesIcon serv--UiBundlesIcon
   :serv/UiBundlesIcon serv--UiBundlesIcon
   :UiIcon serv--UiIcon
   :serv/UiIcon serv--UiIcon
   :UserGroupsIcon serv--UserGroupsIcon
   :serv/UserGroupsIcon serv--UserGroupsIcon
   :VirtualHostIcon serv--VirtualHostIcon
   :serv/VirtualHostIcon serv--VirtualHostIcon
   :WebActionIcon serv--WebActionIcon
   :serv/WebActionIcon serv--WebActionIcon
   :WorkflowIcon serv--WorkflowIcon
   :serv/WorkflowIcon serv--WorkflowIcon})

(defn up-icon [{:keys [icon-type style] :as args}]
  (when-let [Component (get up-icons (keyword icon-type))]
    [:div {:style (merge {:color (style/alc-color "Icons/primary")
                          :flex "0 0 auto"}
                         style)}
     [:> Component (dissoc args :icon-type :fill)]]))

(defn up-secondary-icon [{:keys [style] :as args}]
  [up-icon (assoc args :style (merge {:color (style/alc-color "Icons/secondary")}
                                     style))])
